export const environment = {
  production: false,
  apiUrl: 'http://localhost:8080/api',
  useMockData: true,
  supportEmail: 'soporte-local@canchasyacl.com'
};
